

































































import Vue from "vue";
import { CalendarDay } from "../api/Abrechnung";
export default Vue.extend({
  name: "DameMonatsblattZusammenfuehrenDialog",
  props: {
    visible: { type: Boolean, required: true },
    selectedDays: { type: Object, required: true, validator: (o: any) => true },
    monat: { type: Number, required: true },
  },
  data() {
    return {
      optionen: [] as CalendarDay[],
      selectedDay: null as CalendarDay | null,
      saveButtonIcon: "",
      saveButtonLabel: "",
    };
  },
  mounted() {
    this.updateOptions();
  },
  watch: {
    selectedDays() {
      this.updateOptions();
    },
  },
  methods: {
    updateOptions() {
      this.optionen = Object.keys(this.selectedDays).map(
        (k) => this.selectedDays[k] as CalendarDay
      );
      this.selectedDay = null;
      this.updateButton();
    },
    updateButton() {
      if (this.selectedDay) {
        const summe = this.optionen.reduce(
          (sum, calendarDay) => sum + calendarDay.miete,
          0
        );
        this.saveButtonIcon = "pi pi-save";
        this.saveButtonLabel = `Summe von ${summe} € auf den ${this.selectedDay.tag}.${this.monat}. buchen`;
      } else {
        this.saveButtonIcon = "pi pi-info";
        this.saveButtonLabel = `Buchungstag auswählen`;
      }
    },
  },
});
